import React from 'react';
import { motion } from 'framer-motion';
import { MonitorPlay, Users, Calculator, Laptop } from 'lucide-react';
const features = [{
  icon: Calculator,
  title: 'Carga Rápida de Inventario',
  description: 'Registra las facturas de tus proveedores y el sistema suma el stock automáticamente. ¡Olvídate de buscar repuestos o víveres uno por uno para actualizar tu almacén!'
}, {
  icon: Laptop,
  title: 'Múltiples Negocios y Cajas',
  description: '¿Tienes 3 computadoras o varias sucursales? Haz las copias del archivo que necesites sin pagar licencias extra. Úsalo con tu lector de código de barras y tiquetera de 80mm.'
}, {
  icon: Users,
  title: 'Precios Flexibles y Fiados',
  description: 'Asigna márgenes distintos (ej. 30% a chucherías, 8% a refrescos) y crea precios especiales para esos clientes que te pagan a crédito a los 15 días. Protege tu capital.'
}, {
  icon: MonitorPlay,
  title: 'Cierre de Caja Neta en 2 Minutos',
  description: 'Al final del día, el Dashboard te dirá exactamente cuánto vendiste en $, en Bs por Pago Móvil y tu rentabilidad real. Toma decisiones como un verdadero gerente.'
}];
export function Features() {
  return <section className="py-16 md:py-24 px-4 md:px-6 lg:px-8 max-w-7xl mx-auto relative" data-id="element-54">
      <div className="text-center mb-16 md:mb-20" data-id="element-55">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="font-heading text-3xl md:text-4xl lg:text-5xl font-black text-white tracking-tight mb-6" data-id="element-56">
          Diseñado para el ritmo <span className="text-cyan-400" data-id="element-57">de tu Mostrador</span>
        </motion.h2>
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.1
      }} className="text-gray-400 text-lg md:text-xl max-w-2xl mx-auto font-light" data-id="element-58">
          Todo lo que necesitas para automatizar tus operaciones, sin instalaciones pesadas ni depender de internet todo el tiempo.
        </motion.p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-59">
        <motion.div className="grid grid-cols-1 sm:grid-cols-2 gap-6" data-id="element-60">
          {features.map((feature, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white/5 border border-white/10 rounded-2xl p-6 hover:bg-white/10 hover:border-cyan-500/30 transition-colors duration-300 group" data-id="element-61">
              <div className="w-12 h-12 bg-cyan-500/10 rounded-xl flex items-center justify-center mb-4 group-hover:bg-cyan-500/20 group-hover:scale-110 transition-all duration-300" data-id="element-62">
                <feature.icon className="w-6 h-6 text-cyan-400" data-id="element-63" />
              </div>
              <h3 className="text-white font-bold text-lg mb-2" data-id="element-64">{feature.title}</h3>
              <p className="text-gray-400 text-sm leading-relaxed" data-id="element-65">{feature.description}</p>
            </motion.div>)}
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 40
      }} whileInView={{
        opacity: 1,
        scale: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative lg:ml-10 mt-10 lg:mt-0" data-id="element-66">
          <div className="absolute inset-0 bg-gradient-to-tr from-cyan-500/10 to-green-500/10 rounded-[40px] blur-3xl transform rotate-3" data-id="element-67" />
          
          <div className="relative w-full aspect-video bg-[#0a0a0a] border border-cyan-500/20 rounded-3xl p-2 shadow-[0_0_60px_rgba(34,211,238,0.15)] overflow-hidden" data-id="element-68">
             {/* AQUÍ VA TU VIDEO DE COSTOS */}
             <iframe className="w-full h-full rounded-2xl" src="https://www.youtube.com/embed/xmRK7I_rwk8?autoplay=0&rel=0" title="Demo Masterkit Elite Costos" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen data-id="element-69">
             </iframe>
          </div>
          <p className="text-center text-gray-400 mt-4 text-sm font-medium" data-id="element-70">🎥 Módulo de Estructura de Costos y Fijación de Precios</p>
        </motion.div>
      </div>
    </section>;
}